'use client';

import { useAtom } from 'jotai';

import { Info } from '@gds/Icons/Paths/Info';

import { isInfoModalOpenAtom } from './SearchInfoModal';

import styles from './SearchInfoModal.module.css';

export const SearchInfoToggle = () => {
  const [_, setIsInfoModalOpen] = useAtom(isInfoModalOpenAtom);

  return (
    <div className={styles.infoIcon}>
      <Info onClick={() => setIsInfoModalOpen(true)} />
    </div>
  );
};
